// removed by extract-text-webpack-plugin
module.exports = {"root":"CommonLabel-module-root-2v6c-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CommonLabel/CommonLabel.module.scss
// module id = 982
// module chunks = 0